// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skipBtn_skip__2jHdM {\n  position: sticky;\n  bottom: 0;\n  margin: 0 auto;\n  justify-content: space-around;\n  width: 70px;\n  display: flex;\n  align-items: center;\n  background: var(--primary-dark);\n  border-radius: 15px;\n}\n.skipBtn_skip__2jHdM button {\n  flex: 1;\n  background: var(--primary-dark);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 15px;\n}", ""]);
// Exports
exports.locals = {
	"skip": "skipBtn_skip__2jHdM"
};
module.exports = exports;
